module.exports = __webpack_public_path__ + "static/media/pod_active.1a3c0614.svg";